var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatRtl = function SvgChatRtl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.732 35c-.957 0-1.732.672-1.732 1.5 0 .81.74 1.47 1.667 1.499l.065.001h32.536c.957 0 1.732-.672 1.732-1.5 0-.81-.74-1.47-1.667-1.499L66.268 35zm8.018 10c-.967 0-1.75.672-1.75 1.5 0 .81.748 1.47 1.684 1.499l.065.001h16.502c.966 0 1.749-.672 1.749-1.5 0-.81-.748-1.47-1.684-1.499L58.251 45z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19 15a7 7 0 0 0-7 7v41.077a7 7 0 0 0 7 7h31l16.479 14.1a2 2 0 0 0 3.3-1.52v-12.58H81a7 7 0 0 0 7-7V22a7 7 0 0 0-7-7zm-.5 5.5 63.117-.007a1 1 0 0 1 .993.884l.007.116L82.5 63.5a1 1 0 0 1-.883.993l-.117.007h-17v11l-12.283-11H18.5a1 1 0 0 1-.993-.883L17.5 63.5v-42a1 1 0 0 1 .883-.993z",
    clipRule: "evenodd"
  })));
};
export default SvgChatRtl;